define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/FInspAssetAttr", "lodash.debounce", "../services/EventManager", "../services/SrmsServiceManager"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, FInspAssetAttr_1, lodash_debounce_1, EventManager_1, SrmsServiceManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FInspAsset = void 0;
    lodash_debounce_1 = tslib_1.__importDefault(lodash_debounce_1);
    class FInspAsset extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "InspId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "InspIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAssetId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAssetIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetTypeId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetTypeIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Barcode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "BarcodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefNo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefNoError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OwnerType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OwnerTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateOwnershipPc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateOwnershipPcError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Status", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Condition", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ConditionError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Qty", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "QtyError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RemainingLife", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RemainingLifeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedLife", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedLifeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UserComment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UserCommentError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsModified", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsModifiedError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TransferFId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TransferFIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Shape", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FInspAssetAttr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFInspAssetAttr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FInspAssetAttrError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FInspection", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "onAnyChangeBatchFn", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TransferFLabel", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TransferFLabelTooltip", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RemLifeYears", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedRemLifeYears", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedRemLifeMonths", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FInspAsset.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.FInspection = parent;
            this.InspId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.FInspAssetAttr = [];
        }
        onRead(entity, parent) {
            this.FInspection = parent;
            this.FInspAssetAttr = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.InspId = (0, EntityUtil_1.toInt)(entity.InspId);
            a.FAssetId = (0, EntityUtil_1.toInt)(entity.FAssetId);
            a.AssetTypeId = (0, EntityUtil_1.toInt)(entity.AssetTypeId);
            a.Barcode = b.Barcode;
            a.RefNo = b.RefNo;
            a.OwnerType = (0, EntityUtil_1.toInt)(entity.OwnerType);
            a.StateOwnershipPc = (0, EntityUtil_1.toFloat)(entity.StateOwnershipPc);
            a.Status = (0, EntityUtil_1.toInt)(entity.Status);
            a.Condition = (0, EntityUtil_1.toInt)(entity.Condition);
            a.Qty = (0, EntityUtil_1.toInt)(entity.Qty);
            a.RemainingLife = (0, EntityUtil_1.toInt)(entity.RemainingLife);
            a.SuggestedLife = (0, EntityUtil_1.toInt)(entity.SuggestedLife);
            a.UserComment = b.UserComment;
            a.IsModified = (0, EntityUtil_1.toInt)(entity.IsModified);
            a.TransferFId = (0, EntityUtil_1.toInt)(entity.TransferFId);
            a.FInspAssetAttr = this.mergeArray(a.FInspAssetAttr, b.FInspAssetAttr, FInspAssetAttr_1.FInspAssetAttr);
            a.SelectedFInspAssetAttr = a.SelectedFInspAssetAttr && a.FInspAssetAttr.find(x => x.Id == a.SelectedFInspAssetAttr.Id) ? a.SelectedFInspAssetAttr : null;
            a.Shape = (0, EntityUtil_1.mergePoint)(a.Shape, b.Shape);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
            this.RemLifeYears = Math.floor(this.RemainingLife / 12);
            this.SuggestedRemLifeYears = Math.floor(this.SuggestedLife / 12);
            this.SuggestedRemLifeMonths = this.SuggestedLife % 12;
            this.addChangeEventAction("RemLifeYears", this.onRemLifeYearChange.bind(this));
            this.addChangeEventAction("SuggestedRemLifeYears", this.onSuggestedLifeYearChange.bind(this));
            this.addChangeEventAction("SuggestedRemLifeMonths", this.onSuggestedLifeMonthChange.bind(this));
            this.onAnyChangeBatchFn = (0, lodash_debounce_1.default)(this.onAnyChange, 1000);
            this.addChangeEventAction("AssetTypeId", this.onAnyChangeBatchFn.bind(this));
            this.addChangeEventAction("TransferFId", this.onAnyChangeBatchFn.bind(this));
            this.addChangeEventAction("OwnerType", this.onAnyChangeBatchFn.bind(this));
            this.addChangeEventAction("StateOwnershipPc", this.onAnyChangeBatchFn.bind(this));
            this.addChangeEventAction("Status", this.onAnyChangeBatchFn.bind(this));
            this.addChangeEventAction("Condition", this.onAnyChangeBatchFn.bind(this));
            this.addChangeEventAction("Qty", this.onAnyChangeBatchFn.bind(this));
            this.addChangeEventAction("RemainingLife", this.onAnyChangeBatchFn.bind(this));
            this.addChangeEventAction("SuggestedLife", this.onAnyChangeBatchFn.bind(this));
            this.addChangeEventAction("UserComment", this.onAnyChangeBatchFn.bind(this));
            this.addChangeEventAction("PersistanceState", this.onAnyChangeBatchFn.bind(this));
            if (this.TransferFId > 0) {
                this.TransferFLabel = "";
                let q = {};
                q.Id = this.TransferFId;
                SrmsServiceManager_1.SrmsServiceManager.Instance.Facility.findFacility(q, true).then(matches => {
                    if (matches.length == 1) {
                        let f = matches[0];
                        this.TransferFLabel = f.FacilityId + " (" + f.FacilityName + ")";
                    }
                    else {
                        console.log("Expected only 1 Facility");
                    }
                });
            }
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FInspAsset.AliasName);
            this.reset();
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "FAssetId", "Facility Asset Id");
                this.validateReqNumber(validationState, "AssetTypeId", "Asset Type Id");
                this.validateReqNumber(validationState, "OwnerType", "Owner Type");
                this.validateReqNumber(validationState, "StateOwnershipPc", "State Ownership (%)", { isPc: true });
                this.validateReqNumber(validationState, "Status", "Status");
                this.validateReqNumber(validationState, "Condition", "Condition");
                this.validateReqNumber(validationState, "IsModified", "Has Changes?");
            }
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "FAssetId", "Facility Asset Id");
                this.validateReqNumber(validationState, "AssetTypeId", "Asset Type Id");
                this.validateReqNumber(validationState, "OwnerType", "Owner Type");
                this.validateReqNumber(validationState, "StateOwnershipPc", "State Ownership (%)", { precision: 2 });
                this.validateReqNumber(validationState, "Status", "Status");
                this.validateReqNumber(validationState, "Condition", "Condition");
                this.validateReqNumber(validationState, "IsModified", "Has Changes?");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.FInspAssetAttr) {
                for (let x of this.FInspAssetAttr) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                InspId: this.InspId,
                FAssetId: this.FAssetId,
                AssetTypeId: this.AssetTypeId,
                Barcode: this.Barcode,
                RefNo: this.RefNo,
                OwnerType: this.OwnerType,
                StateOwnershipPc: this.StateOwnershipPc,
                Status: this.Status,
                Condition: this.Condition,
                Qty: this.Qty,
                RemainingLife: this.RemainingLife,
                SuggestedLife: this.SuggestedLife,
                UserComment: this.UserComment,
                IsModified: this.IsModified,
                TransferFId: this.TransferFId,
                FInspAssetAttr: this.FInspAssetAttr.map(x => x.toJson()),
                Shape: this.Shape.toJSON(),
                IsGeometryModified: this.IsGeometryModified,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        get ExpectedLifeDesc() {
            let remYears = Math.floor(this.RemainingLife / 12);
            let remMonths = this.RemainingLife % 12;
            if (remYears > 0) {
                if (remMonths > 0) {
                    return `${remYears}Y ${remMonths}M`;
                }
                else {
                    return `${remYears}Y`;
                }
            }
            else if (remMonths > 0) {
                return `${remMonths}M`;
            }
            else {
                return "Expired";
            }
        }
        onRemLifeYearChange() {
            this.RemainingLife = (this.RemLifeYears * 12);
        }
        onSuggestedLifeYearChange() {
            this.SuggestedLife = (this.SuggestedRemLifeYears * 12) + this.SuggestedRemLifeMonths;
        }
        onSuggestedLifeMonthChange() {
            this.SuggestedLife = (this.SuggestedRemLifeYears * 12) + this.SuggestedRemLifeMonths;
        }
        onAnyChange() {
            this.IsModified = 1;
        }
        static create(insp) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Creating Asset");
                SrmsServiceManager_1.SrmsServiceManager.Instance.Facility.createFacilityInspectionAsset(insp.Id, insp.Shape).then(a => {
                    let x = new FInspAsset(a, insp);
                    insp.FInspAsset.push(x);
                    resolve(x);
                });
            });
        }
        get AssetType() {
            if (this.FInspection && this.FInspection.Facility && this.FInspection.Facility.AssetTypes) {
                return this.FInspection.Facility.AssetTypes.find(at => at.Id == this.AssetTypeId);
            }
            return null;
        }
        get TypeDesc() {
            if (this.AssetType) {
                return this.AssetType.AssetTypeDesc;
            }
            else {
                return "";
            }
        }
        get InstanceDesc() {
            if (this.AssetType) {
                return `${this.Barcode} - ${this.AssetType.AssetTypeDesc}`;
            }
            else {
                return "";
            }
        }
        get ApplicableAssetAttributes() {
            let assetType = this.AssetType;
            if (this.FInspection.Facility.AssetAttributeTypes) {
                return this.FInspection.Facility.AssetAttributeTypes.filter(aat => {
                    return (aat.AssetGroup == assetType.AssetGroup) && (aat.AssetDesc == assetType.AssetDesc || aat.AssetDesc == null || aat.AssetDesc.trim().length == 0);
                });
            }
            else {
                return [];
            }
        }
        get UnassignedAttributeTypes() {
            return this.ApplicableAssetAttributes.filter(aa => {
                return !this.IsAttributeTypeAssigned(aa);
            });
        }
        IsAttributeTypeAssigned(type) {
            return this.FInspAssetAttr.findIndex((aa) => aa.AttrTypeId == type.Id) > -1;
        }
        updateAssetAttributes() {
            for (let i = this.FInspAssetAttr.length - 1; i >= 0; i--) {
                let attr = this.FInspAssetAttr[i];
                if (attr.AssetAttributeType.AssetGroup != this.AssetType.AssetGroup) {
                    if (attr.PersistanceState == EntityBase_1.PersistanceStates.NEW_RECORD) {
                        this.FInspAssetAttr.splice(i, 1);
                    }
                    else {
                        attr.markForDeletion();
                    }
                }
                else {
                    if (attr.PersistanceState == EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                        attr.PersistanceState = attr.PersistanceStateBeforeDelete;
                    }
                }
            }
        }
        get IsNewAsset() {
            return this.FAssetId == -1;
        }
    }
    exports.FInspAsset = FInspAsset;
    Object.defineProperty(FInspAsset, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FInspAsset"
    });
    Object.defineProperty(FInspAsset, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Inspection Asset"
    });
    Object.defineProperty(FInspAsset, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "InspId", "FAssetId", "AssetTypeId", "Barcode", "RefNo", "OwnerType", "StateOwnershipPc", "Status", "Condition", "Qty", "RemainingLife", "SuggestedLife", "UserComment", "IsModified", "TransferFId", "Shape"]
    });
    Object.defineProperty(FInspAsset, "InspIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspAsset, "FAssetIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspAsset, "AssetTypeIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspAsset, "BarcodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FInspAsset, "BarcodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspAsset, "RefNoLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 11
    });
    Object.defineProperty(FInspAsset, "RefNoReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspAsset, "OwnerTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspAsset, "OwnerTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspAsset, "StateOwnershipPcReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspAsset, "StatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspAsset, "StatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspAsset, "ConditionDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspAsset, "ConditionReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspAsset, "QtyTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Quantity (leave empty if zero)"
    });
    Object.defineProperty(FInspAsset, "QtyReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspAsset, "RemainingLifeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspAsset, "SuggestedLifeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspAsset, "UserCommentLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2048
    });
    Object.defineProperty(FInspAsset, "UserCommentReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FInspAsset, "IsModifiedReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FInspAsset, "TransferFIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "InspId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "InspIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "FAssetId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "FAssetIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "AssetTypeId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "AssetTypeIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "Barcode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "BarcodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "RefNo", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "RefNoError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "OwnerType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "OwnerTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "StateOwnershipPc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "StateOwnershipPcError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "Status", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "StatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "Condition", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "ConditionError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "Qty", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "QtyError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "RemainingLife", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "RemainingLifeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "SuggestedLife", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "SuggestedLifeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "UserComment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "UserCommentError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "IsModified", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "IsModifiedError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "TransferFId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "TransferFIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "Shape", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "FInspAssetAttr", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "SelectedFInspAssetAttr", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "FInspAssetAttrError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "FInspection", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FInspAsset.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FInspAsset.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FInspAsset.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "TransferFLabel", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "TransferFLabelTooltip", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "RemLifeYears", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "SuggestedRemLifeYears", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FInspAsset.prototype, "SuggestedRemLifeMonths", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspAsset.prototype, "ExpectedLifeDesc", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspAsset.prototype, "AssetType", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspAsset.prototype, "TypeDesc", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspAsset.prototype, "InstanceDesc", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspAsset.prototype, "ApplicableAssetAttributes", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspAsset.prototype, "UnassignedAttributeTypes", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FInspAsset.prototype, "IsNewAsset", null);
});
